
import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

// const Load1Svg = ({ svgColor }) => {
//     const [logData, setLogData] = useState(null); // Initialize as null or an object
//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID"),
//         LOC_CODE: localStorage.getItem("LCODE"),
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });

//     const fetchLogData = async () => {
//         try {
//             const res = await logApi(credentials);
//             if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//                 // Assuming you need the first object in the array
//                 setLogData(res.TOT_LIVE_KW_NEW[0]);
//             } else {
//                 setLogData(null); // Handle no data scenario
//             }
//         } catch (error) {
//             console.error("Error fetching log data:", error);
//             setLogData(null); // Handle error scenario
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials]);



//     // Determine the color for the SOLAR value
//     const solarColor =
//         logData?.SOLAR == null
//             ? "gray" // No data
//             : logData.SOLAR <= 0
//                 ? "red" // Solar < 1
//                 : "green"; // Solar >= 1

//     // Determine the color for the LOAD value
//     const loadColor =
//         logData?.TOTAL_LOAD == null
//             ? "gray" // No data
//             : logData.TOTAL_LOAD <= 0
//                 ? "red" // Solar < 1
//                 : "green"; // Solar >= 1


//     // Determine the color for the DG value
//     const dgColor =
//         logData?.GenSet == null
//             ? "gray" // No data
//             : logData.GenSet <= 0
//                 ? "red" // Solar <= 0
//                 : "green"; // Solar > 0




//     return (
//         <>

{/* <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100%" height="100%" viewBox="0 0 869.000000 521.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,521.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke={svgColor}> */}

// {/* //grid  */}

// <path d="M7058 5132 c-12 -2 -18 -13 -18 -32 0 -16 -6 -35 -14 -42 -7 -8 -26
// -53 -40 -101 -16 -52 -32 -87 -40 -87 -7 0 -23 -19 -36 -42 -12 -24 -44 -61
// -71 -82 -51 -41 -106 -133 -90 -149 12 -12 31 0 31 19 0 21 20 17 41 -8 19
// -21 19 -21 19 -1 0 22 18 33 52 33 11 0 18 5 16 13 -3 7 -27 13 -58 15 l-54 3
// 74 70 75 70 7 -58 c10 -83 3 -133 -24 -159 -32 -31 -53 -57 -61 -77 -3 -9 -13
// -17 -22 -17 -8 0 -15 -5 -15 -11 0 -6 -11 -20 -25 -31 -14 -11 -25 -26 -25
// -34 0 -8 -7 -17 -15 -20 -10 -4 -15 -20 -15 -45 0 -47 14 -51 29 -8 8 23 15
// 30 27 25 8 -3 18 -6 20 -6 2 0 5 -12 5 -27 l1 -28 7 30 c5 25 12 31 39 33 54
// 5 36 22 -25 22 -50 1 -56 2 -40 14 9 7 17 17 17 22 1 14 44 59 63 67 9 3 17
// 13 17 21 0 9 9 20 20 26 19 10 20 7 22 -47 4 -119 0 -149 -21 -195 -11 -26
// -21 -56 -21 -67 0 -11 -4 -23 -10 -26 -5 -3 -10 -19 -10 -36 0 -16 -3 -29 -8
// -29 -7 0 -22 -37 -45 -112 l-11 -38 -103 0 c-62 0 -103 -4 -103 -10 0 -7 174
// -10 503 -9 326 0 491 4 472 10 -16 5 -74 9 -128 8 l-99 -2 -22 49 c-13 27 -29
// 67 -36 89 -7 22 -16 42 -19 45 -3 3 -15 28 -26 55 -15 39 -20 79 -22 185 l-3
// 135 23 -27 c12 -16 30 -28 40 -28 9 0 17 -5 17 -11 0 -7 17 -28 37 -48 l37
// -36 -62 -3 c-62 -3 -89 -22 -31 -22 22 0 32 -5 36 -20 3 -11 11 -20 18 -20 7
// 0 15 9 18 20 8 29 27 24 38 -10 6 -16 15 -30 20 -30 15 0 10 67 -6 80 -8 7
// -15 18 -15 24 -1 17 -58 76 -75 76 -8 0 -15 6 -15 13 0 7 -18 29 -40 50 -39
// 35 -40 38 -40 102 0 45 -4 65 -12 65 -10 0 -10 2 -1 8 6 4 13 20 15 35 3 29 3
// 29 71 -36 37 -35 67 -67 67 -70 0 -3 -23 -7 -50 -9 -57 -3 -72 -21 -22 -26 24
// -2 32 -8 32 -23 0 -25 27 -25 35 1 3 11 12 20 20 20 7 0 15 -9 18 -20 6 -24
// 22 -26 31 -5 12 31 -24 80 -130 176 -63 58 -102 109 -109 142 -8 42 -36 119
// -47 132 -4 5 -8 16 -8 25 -1 38 -44 63 -92 52z m62 -46 c0 -14 4 -27 9 -30 4
// -3 11 -19 14 -35 4 -16 16 -50 28 -75 33 -70 26 -76 -86 -76 -87 0 -95 2 -95
// 19 0 25 18 74 31 82 5 3 14 31 19 62 11 72 15 77 51 77 24 0 29 -4 29 -24z
// m35 -246 c7 -11 -32 -65 -54 -75 -17 -7 -61 21 -61 39 0 7 -10 21 -22 29 -22
// 15 -19 16 54 16 42 1 80 -4 83 -9z m45 -106 l0 -76 -40 32 c-22 17 -40 37 -40
// 43 0 9 67 75 78 77 1 0 2 -34 2 -76z m-159 23 c20 -24 7 -58 -28 -74 -23 -11
// -23 -11 -23 54 0 61 1 64 18 52 9 -7 24 -22 33 -32z m86 -79 c18 -18 33 -36
// 33 -40 0 -4 -35 -8 -77 -8 -58 1 -73 3 -60 11 9 5 17 16 17 23 0 12 35 44 50
// 45 2 1 19 -13 37 -31z m16 -110 c-11 -13 -26 -33 -32 -46 -16 -31 -40 -24 -62
// 17 -10 19 -24 38 -31 43 -7 4 21 8 66 8 l79 0 -20 -22z m53 -166 c-3 -3 -22
// 11 -41 31 -36 37 -46 67 -22 67 7 0 24 15 38 33 l24 32 3 -79 c2 -43 0 -81 -2
// -84z m-153 104 c18 -17 18 -19 2 -51 -10 -17 -26 -37 -36 -44 -18 -10 -19 -7
// -19 65 0 83 0 83 53 30z m74 -73 c4 -10 22 -31 41 -48 38 -34 36 -52 -6 -78
// -15 -9 -36 -27 -47 -39 l-19 -24 -38 38 c-21 21 -42 38 -48 38 -18 0 -10 40
// 11 52 11 7 29 28 40 46 23 35 56 43 66 15z m-89 -163 c12 0 16 -25 12 -64 -2
// -18 -104 -126 -120 -126 -4 0 -10 -9 -13 -19 -2 -10 -13 -24 -24 -29 -17 -10
// -19 -8 -15 19 2 16 8 29 12 29 4 0 13 26 20 58 12 56 31 104 59 150 l14 23 22
// -21 c12 -11 27 -20 33 -20z m192 14 c0 -8 5 -14 10 -14 6 0 10 -11 10 -24 0
// -13 9 -43 20 -67 11 -24 20 -53 20 -63 0 -10 6 -24 14 -30 8 -6 17 -21 21 -33
// 13 -45 -27 -24 -101 55 -40 42 -73 82 -74 89 0 6 -5 13 -11 15 -20 7 0 44 38
// 71 37 27 53 27 53 1z m-39 -183 c89 -89 105 -112 72 -106 -10 2 -91 4 -180 4
// -138 1 -163 3 -163 16 0 8 5 15 11 15 15 0 79 65 79 80 0 5 6 10 13 10 6 0 25
// 16 40 35 15 19 30 35 33 35 3 0 45 -40 95 -89z"
// fill={
//     logData?.GRID == null
//       ? "gray" // No data
//       : logData.GRID <= 0
//       ? "red" // Grid < 1
//       : "green" // Grid > 0
//   }
// />

// {/* //path */}

// <path d="M5414 4445 c-3 -8 -4 -20 -1 -27 4 -8 6 -6 6 5 1 10 9 17 20 17 11 0
// 23 5 26 10 4 6 -5 10 -20 10 -14 0 -28 -7 -31 -15z"
// fill={svgColor}
// />
// <path d="M5600 4450 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10
// -14 0 -25 -4 -25 -10z" fill={svgColor}/>
// <path d="M5800 4450 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11
// 0 -20 -4 -20 -10z" fill={svgColor}/>
// <path d="M5990 4450 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
// -16 0 -30 -4 -30 -10z" fill={svgColor}/>


// <path d="M5413 4270 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" fill={svgColor}/>
// <path d="M5413 4055 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" fill={svgColor}/>
// <path d="M5413 3845 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z" fill={svgColor}/>
// <path d="M5413 3650 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" fill={svgColor}/>

// {/* //solar */}
// <path d="M900 3378 c1 -40 2 -42 16 -23 17 23 15 56 -3 63 -9 2 -13 -9 -13
// -40z" fill={solarColor}/>


// <path d="M740 3383 c0 -22 26 -73 37 -73 18 0 16 16 -4 51 -16 27 -33 38 -33
// 22z" fill={solarColor}/>
// <path d="M1032 3357 c-14 -40 -15 -47 -3 -47 13 0 30 55 22 68 -4 7 -12 -2
// -19 -21z" fill={solarColor}/>
// <path d="M843 3283 c-13 -2 -23 -8 -23 -13 0 -5 -13 -16 -28 -24 -30 -16 -47
// -44 -57 -99 -9 -48 35 -142 71 -151 32 -8 44 -1 44 29 0 13 7 30 15 38 7 8 17
// 26 21 41 7 31 51 46 137 46 39 0 57 4 57 13 0 20 -49 87 -64 87 -7 0 -23 9
// -36 20 -23 20 -77 25 -137 13z" fill={solarColor}/>

// {/* //ring circle */}
// <path d="M3995 3283 c-27 -6 -79 -26 -85 -32 -3 -3 -19 -13 -35 -22 -77 -40
// -124 -80 -125 -106 0 -6 -8 -18 -18 -25 -48 -34 -92 -160 -99 -283 -5 -73 -2
// -105 16 -168 23 -86 56 -158 77 -170 8 -4 14 -14 14 -22 0 -7 15 -25 33 -39
// 17 -15 43 -36 57 -48 13 -11 36 -25 50 -32 14 -6 27 -13 30 -16 48 -52 322
// -50 383 2 12 11 37 26 55 33 17 8 32 18 32 24 0 5 16 18 35 30 19 11 35 27 35
// 34 0 8 9 22 20 32 11 10 20 24 20 31 0 7 8 21 18 31 33 32 62 149 62 247 0 94
// -29 221 -55 242 -8 6 -19 22 -25 35 -32 71 -97 139 -160 166 -19 8 -39 21 -45
// 28 -17 22 -85 35 -180 34 -49 -1 -99 -3 -110 -6z m165 -32 c0 -4 24 -11 52
// -14 29 -4 65 -16 80 -27 15 -11 30 -20 34 -20 3 0 34 -28 68 -61 55 -56 106
// -135 106 -166 0 -7 4 -13 9 -13 12 0 31 -103 31 -164 -1 -67 -15 -139 -29
// -144 -6 -2 -11 -10 -11 -18 0 -37 -57 -133 -107 -181 -30 -29 -59 -53 -65 -53
// -6 0 -16 -8 -23 -17 -13 -17 -85 -43 -122 -43 -13 0 -23 -4 -23 -10 0 -6 -27
// -10 -60 -10 -33 0 -60 4 -60 9 0 5 -17 11 -37 14 -44 6 -112 30 -122 44 -3 5
// -22 20 -41 33 -42 28 -89 80 -90 98 0 6 -8 20 -17 30 -10 9 -27 37 -38 62 -17
// 38 -20 66 -20 195 0 158 5 181 58 239 9 11 17 25 17 31 0 10 37 50 105 113 17
// 15 59 36 93 47 34 11 62 23 62 27 0 5 34 8 75 8 41 0 75 -4 75 -9z" fill={svgColor}/>
// <path d="M5412 3215 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z" fill={svgColor}/>

// <path d="M620 3265 c0 -8 16 -19 38 -24 55 -16 60 -14 30 14 -30 27 -68 33
// -68 10z" fill={solarColor} />
// <path d="M1160 3274 c0 -6 -15 -18 -32 -27 l-33 -18 35 6 c42 7 52 16 40 35
// -5 8 -10 10 -10 4z" fill={solarColor}/>

// <path d="M608 3133 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={solarColor}/>
// <path d="M906 3070 c-27 -68 -25 -70 59 -70 l75 0 0 39 c0 22 3 46 6 55 5 14
// -4 16 -59 16 l-65 0 -16 -40z" fill={solarColor}/>
// <path d="M1075 3078 c-6 -18 -9 -43 -7 -56 3 -22 7 -23 85 -20 l82 3 5 53 6
// 52 -81 0 -80 0 -10 -32z" fill={solarColor} />
// <path d="M1290 3095 c0 -8 -4 -15 -10 -15 -5 0 -10 -18 -10 -40 l0 -40 105 0
// 105 0 0 55 0 55 -95 0 c-78 0 -95 -3 -95 -15z" fill={solarColor}/>
// <path d="M1510 3055 l0 -55 84 0 c47 0 87 4 91 9 3 5 0 30 -7 55 l-12 46 -78
// 0 -78 0 0 -55z" fill={solarColor}/>
// <path d="M1709 3055 l16 -55 78 0 c86 0 87 1 65 71 l-11 39 -82 0 -82 0 16
// -55z" fill={solarColor}/>
// <path d="M5413 3030 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z" fill={svgColor}/>
// <path d="M673 3031 c-3 -11 -12 -22 -22 -25 -9 -2 0 -4 19 -3 28 2 36 6 38 25
// 4 28 -28 31 -35 3z" fill={solarColor}/>
// <path d="M872 2965 c-7 -8 -15 -29 -19 -46 -3 -17 -12 -33 -19 -36 -34 -13 -8
// -23 61 -23 41 0 75 4 75 9 0 5 11 12 24 15 22 5 36 37 36 82 0 20 -140 19
// -158 -1z" fill={solarColor}/>
// <path d="M1056 2972 c-2 -4 -7 -24 -11 -44 -11 -56 7 -68 99 -68 84 0 77 -7
// 91 83 l6 37 -90 0 c-49 0 -92 -3 -95 -8z" fill={solarColor}/>
// <path d="M1266 2943 c-14 -88 -20 -83 108 -83 67 0 116 4 118 10 2 5 1 32 0
// 60 l-4 50 -108 0 -107 0 -7 -37z" fill={solarColor}/>
// <path d="M1520 2939 c0 -65 21 -79 116 -79 l77 0 -7 47 c-3 26 -10 51 -14 55
// -4 4 -44 10 -90 14 l-82 7 0 -44z" fill={solarColor}/>
// <path d="M1739 2973 c-11 -3 -15 -12 -11 -28 2 -14 8 -25 12 -25 4 0 10 -13
// 14 -30 l6 -30 75 0 75 0 0 43 c0 23 -4 47 -8 53 -7 11 -133 24 -163 17z" fill={solarColor}/>
// <path d="M755 2928 c-8 -21 -10 -34 -3 -37 14 -5 25 9 33 42 10 39 -13 35 -30
// -5z" fill={solarColor}/>
// <path d="M4693 2953 c-24 -9 -13 -23 17 -23 20 0 30 5 30 15 0 15 -22 19 -47
// 8z" fill={svgColor}/>
// <path d="M4890 2946 c0 -11 9 -16 26 -16 31 0 28 23 -4 28 -15 2 -22 -2 -22
// -12z" fill={svgColor} />
// <path d="M5087 2953 c-15 -15 -5 -23 28 -23 36 0 47 13 19 24 -20 8 -39 8 -47
// -1z" fill={svgColor}/>
// <path d="M5267 2953 c-15 -14 -6 -23 23 -23 20 0 30 5 30 15 0 15 -40 21 -53
// 8z" fill={svgColor}/>
// <path d="M3297 2923 c3 -7 9 -13 13 -13 10 0 50 -85 50 -107 0 -21 -40 -105
// -54 -115 -8 -5 -7 -8 1 -8 16 0 116 40 123 49 3 4 35 19 73 35 37 16 67 32 67
// 36 0 5 -25 18 -55 31 -30 12 -55 26 -55 30 0 3 -27 16 -60 28 -33 12 -60 26
// -60 30 0 5 -11 11 -24 13 -17 4 -23 1 -19 -9z" fill={svgColor}/>
// <path d="M810 2813 c0 -10 -4 -23 -9 -28 -5 -6 -11 -29 -15 -53 l-6 -43 92 3
// 91 3 14 59 c7 33 11 61 8 64 -3 3 -43 8 -90 10 -79 4 -85 3 -85 -15z" fill={solarColor}/>
// <path d="M1030 2806 c-5 -15 -10 -36 -10 -47 0 -10 -4 -19 -10 -19 -5 0 -10
// -11 -10 -25 l0 -25 111 0 111 0 -4 60 c-2 33 -7 63 -11 66 -4 4 -43 9 -87 12
// -79 5 -80 4 -90 -22z" fill={solarColor}/>
// <path d="M1250 2755 l0 -65 130 0 130 0 0 34 c0 18 -3 48 -6 65 l-6 31 -124 0
// -124 0 0 -65z" fill={solarColor}/>
// <path d="M1538 2810 c-1 -5 -1 -35 0 -65 l4 -55 110 0 110 0 -7 33 c-4 17 -11
// 34 -15 37 -4 3 -10 17 -14 33 -6 27 -7 27 -95 27 -50 0 -91 -4 -93 -10z" fill={solarColor}/>
// <path d="M1777 2807 c-2 -7 0 -36 6 -65 l11 -52 86 0 87 0 -4 33 c-2 17 -6 47
// -9 65 l-5 32 -83 0 c-58 0 -85 -4 -89 -13z" fill={solarColor}/>
// <path d="M2250 2810 c0 -5 14 -10 30 -10 17 0 30 5 30 10 0 6 -13 10 -30 10
// -16 0 -30 -4 -30 -10z" fill={svgColor}/>
// <path d="M2470 2810 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10
// -19 0 -35 -4 -35 -10z" fill={svgColor}/>
// <path d="M2680 2806 c0 -10 9 -16 21 -16 24 0 21 23 -4 28 -10 2 -17 -3 -17
// -12z" fill={svgColor}/>
// <path d="M2840 2806 c0 -11 10 -16 31 -16 38 0 35 24 -4 28 -19 2 -27 -1 -27
// -12z" fill={svgColor}/>
// <path d="M3027 2814 c-15 -16 -5 -24 29 -24 24 0 34 4 32 13 -5 13 -50 22 -61
// 11z" fill={svgColor}/>
// <path d="M3233 2813 c-24 -9 -13 -23 18 -23 20 0 29 4 27 13 -5 13 -26 18 -45
// 10z" fill={svgColor}/>
// <path d="M3573 2640 c0 -47 2 -66 4 -42 2 23 2 61 0 85 -2 23 -4 4 -4 -43z" fill={solarColor}/>
// <path d="M742 2582 c-12 -43 -22 -84 -22 -90 0 -8 29 -12 99 -12 l98 0 17 73
// c10 39 20 80 22 90 5 15 -4 17 -93 17 l-98 0 -23 -78z" fill={solarColor}/>
// <path d="M985 2638 c-39 -172 -47 -158 94 -158 l118 0 6 68 c12 124 23 112
// -103 112 -106 0 -110 -1 -115 -22z" fill={solarColor}/>
// <path d="M1236 2599 c-3 -34 -6 -75 -6 -90 l0 -29 148 0 148 0 -7 68 c-5 37
// -8 77 -8 90 -1 22 -3 22 -135 22 l-133 0 -7 -61z" fill={solarColor}/>
// <path d="M1546 2593 c4 -38 10 -70 14 -73 3 -3 9 -13 13 -23 6 -16 19 -17 114
// -15 l108 3 -2 30 c-1 17 -8 56 -15 88 l-12 57 -113 0 -114 0 7 -67z" fill={solarColor}/>
// <path d="M1804 2628 c4 -18 10 -48 13 -65 3 -18 11 -33 19 -33 7 0 14 -10 16
// -22 3 -22 7 -23 93 -23 90 0 90 0 88 25 -4 38 -25 100 -35 100 -4 0 -8 11 -8
// 25 0 25 0 25 -96 25 l-96 0 6 -32z" fill={solarColor}/>
// <path d="M5390 2525 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
// -5 0 -10 -25 -10 -55z" fill={svgColor}/>
// <path d="M1340 2365 l0 -95 40 0 40 0 0 95 0 95 -40 0 -40 0 0 -95z" fill={solarColor}/>
// <path d="M5390 2320 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50
// -5 0 -10 -22 -10 -50z" fill={svgColor}/>
// <path d="M1038 2229 c-10 -10 -29 -19 -42 -19 -14 0 -31 -6 -38 -13 -7 -7 -22
// -18 -33 -25 -15 -9 93 -11 465 -12 317 0 480 4 470 10 -8 5 -23 10 -32 10 -10
// 0 -18 4 -18 9 0 5 -25 17 -55 26 -30 8 -55 20 -55 25 0 6 -120 10 -322 9 -305
// -1 -324 -2 -340 -20z" fill={solarColor}/>
// <path d="M5390 2110 c0 -27 5 -50 10 -50 6 0 10 23 10 50 0 28 -4 50 -10 50
// -5 0 -10 -22 -10 -50z" fill={svgColor}/>
// <path d="M5390 1905 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
// -5 0 -10 -25 -10 -55z" fill={svgColor}/>
// <path d="M7126 1575 c-20 -19 -40 -35 -46 -35 -5 0 -10 -4 -10 -9 0 -5 -10
// -11 -23 -15 -13 -3 -40 -21 -60 -41 -20 -19 -43 -35 -52 -35 -8 0 -15 -4 -15
// -10 0 -15 -42 -50 -85 -70 -22 -10 -50 -32 -63 -49 -12 -17 -29 -31 -37 -31
// -8 0 -15 -4 -15 -10 0 -5 -11 -10 -25 -10 -25 0 -42 -13 -80 -62 -11 -14 -39
// -36 -62 -48 -24 -12 -43 -26 -43 -32 0 -15 27 -38 44 -38 9 0 16 -4 16 -10 0
// -17 22 -11 41 12 11 11 19 24 19 28 0 4 12 13 28 21 37 19 104 61 120 76 6 6
// 12 19 12 27 0 11 13 18 40 22 22 4 40 10 40 15 0 4 9 10 19 14 11 3 23 15 26
// 26 4 10 11 19 17 19 14 0 138 92 138 102 0 4 9 8 21 8 12 0 30 11 41 25 11 14
// 25 25 31 25 7 0 24 -11 39 -25 15 -14 34 -25 42 -25 9 0 28 -12 43 -28 16 -15
// 48 -40 73 -56 24 -16 56 -40 69 -53 14 -12 31 -23 38 -23 7 0 13 -4 13 -9 0
// -5 16 -12 35 -15 23 -5 40 -16 51 -34 8 -15 45 -45 80 -67 35 -22 66 -48 70
// -57 3 -10 12 -18 21 -18 9 0 22 -8 29 -17 13 -17 13 -17 14 0 0 9 6 17 14 17
// 13 0 26 20 26 39 0 5 -17 20 -37 33 -21 14 -57 44 -81 67 -23 22 -49 41 -57
// 41 -8 0 -15 5 -15 10 0 6 -9 10 -20 10 -12 0 -25 10 -32 24 -6 14 -25 30 -42
// 37 -30 12 -118 77 -124 92 -2 4 -10 7 -17 7 -8 0 -25 10 -38 23 -13 12 -34 29
// -46 37 -13 8 -29 21 -37 28 -7 6 -19 12 -26 12 -7 0 -28 16 -45 35 -18 19 -35
// 35 -37 35 -3 0 -21 -16 -40 -35z" fill={loadColor}/>
// <path d="M6700 1445 c0 -54 4 -95 10 -95 5 0 25 7 44 16 24 12 36 25 40 45 4
// 20 12 29 24 29 18 0 42 37 42 65 0 8 -7 15 -15 15 -8 0 -15 5 -15 10 0 6 -28
// 10 -65 10 l-65 0 0 -95z" fill={loadColor}/>
// <path d="M5390 1485 c0 -25 5 -45 10 -45 6 0 10 20 10 45 0 25 -4 45 -10 45
// -5 0 -10 -20 -10 -45z" fill={svgColor}/>
// <path d="M7147 1393 c-9 -10 -38 -29 -64 -43 -26 -13 -62 -39 -80 -56 -18 -18
// -46 -35 -63 -39 -16 -4 -30 -11 -30 -16 0 -16 -62 -69 -88 -76 -12 -3 -27 -14
// -33 -24 -5 -11 -15 -19 -22 -19 -7 0 -19 -9 -27 -20 -8 -11 -20 -20 -27 -20
// -10 0 -13 -56 -13 -265 l0 -265 150 0 150 0 0 84 c0 46 3 98 6 115 l7 31 152
// 0 152 0 7 -61 c3 -34 6 -86 6 -115 l0 -54 160 0 160 0 0 204 c0 111 -3 231 -6
// 265 -6 54 -9 61 -29 61 -13 0 -26 9 -33 24 -6 14 -27 32 -47 42 -20 9 -39 23
// -42 31 -3 7 -14 13 -24 13 -10 0 -19 4 -19 9 0 17 -50 61 -69 61 -23 0 -71 37
// -71 54 0 6 -24 22 -53 35 -28 13 -61 33 -73 43 -20 17 -21 18 -37 1z" fill={loadColor}/>
// <path d="M5390 1295 c0 -30 5 -55 10 -55 6 0 10 25 10 55 0 30 -4 55 -10 55
// -5 0 -10 -25 -10 -55z" fill={svgColor}/>
// <path d="M5463 1163 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" fill={svgColor}/>
// <path d="M5663 1163 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z" fill={svgColor}/>
// <path d="M5868 1163 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" fill={svgColor}/>
// </g>
// </svg>

//         </>
//     );
// };

// export default Load1Svg;




// import React, { useState, useEffect } from "react";
// import { logApi } from "../../api/Api";

const Load1Svg = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
    const solarColor =
        logData?.SOLAR == null
            ? "gray" // No data
            : logData.SOLAR <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1

    // Determine the color for the LOAD value
    const loadColor =
        logData?.TOTAL_LOAD == null
            ? "gray" // No data
            : logData.TOTAL_LOAD <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
        logData?.GenSet == null
            ? "gray" // No data
            : logData.GenSet <= 0
                ? "red" // Solar <= 0
                : "green"; // Solar > 0




    return (
        <>



            <div style={{ width: '100%', maxHeight: '400px', overflow: 'hidden' }}>

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 500 500"

                    preserveAspectRatio="xMidYMid meet"
                    style={{ width: '100%', height: '400px', display: 'block' }}
                >

                    <g transform="translate(-600.000000,1550.000000) scale(0.100000,-0.100000)"
                        fill="#000000" stroke={svgColor}>


                        <path d="M9999 14908 c-6 -11 -27 -66 -45 -121 -33 -99 -34 -100 -137 -206
-100 -102 -139 -163 -115 -177 6 -4 15 1 20 10 11 20 37 21 44 1 8 -21 21 -19
27 5 4 15 14 20 42 20 62 0 36 25 -30 28 l-58 3 74 69 c41 38 77 70 82 70 4 0
7 -42 7 -94 0 -71 -4 -97 -15 -106 -8 -7 -55 -56 -104 -109 -85 -92 -119 -151
-87 -151 7 0 16 9 19 20 3 11 13 20 22 20 9 0 19 -9 22 -20 3 -11 8 -20 12
-20 3 0 12 9 19 20 8 13 23 20 42 20 17 0 30 4 30 9 0 11 -36 21 -80 21 l-34
0 69 70 c38 39 73 70 77 70 5 0 8 -44 8 -99 0 -98 0 -99 -69 -272 l-68 -174
-59 -6 c-53 -5 -50 -6 31 -7 50 0 99 3 110 8 11 5 16 9 10 9 -13 1 166 181
180 181 16 0 196 -170 190 -180 -8 -13 36 -20 125 -18 82 1 83 2 25 7 l-59 6
-73 180 -72 180 3 88 c2 49 7 91 10 95 4 3 39 -26 79 -66 l72 -72 -35 0 c-44
0 -80 -10 -80 -21 0 -5 14 -9 30 -9 18 0 33 -6 36 -15 4 -8 12 -15 19 -15 7 0
15 7 19 15 8 22 37 18 43 -5 8 -29 23 -25 23 6 0 20 -27 54 -111 140 l-111
114 5 86 c3 47 8 89 12 92 8 8 135 -119 135 -135 0 -9 -15 -13 -44 -13 -25 0
-48 -4 -51 -10 -3 -6 5 -10 19 -10 14 0 35 -10 46 -22 20 -21 22 -22 31 -5 12
21 38 22 45 2 10 -25 24 -17 24 14 0 23 -22 52 -111 145 -109 113 -111 118
-145 213 -46 129 -56 143 -99 143 -25 0 -37 -6 -46 -22z m113 -112 c20 -57 34
-107 31 -110 -4 -3 -48 -6 -100 -6 -72 0 -93 3 -93 14 0 12 29 96 62 179 8 20
17 27 37 27 24 0 29 -8 63 -104z m8 -153 c0 -4 -17 -24 -37 -45 l-37 -38 -38
37 c-21 20 -38 41 -38 45 0 4 34 8 75 8 41 0 75 -3 75 -7z m-130 -68 l34 -35
-42 -43 -42 -42 0 78 c0 42 4 77 8 77 4 0 23 -16 42 -35z m170 -40 c0 -41 -3
-75 -7 -75 -4 0 -24 17 -45 37 l-38 37 37 38 c20 21 41 38 45 38 4 0 8 -34 8
-75z m-73 -57 c18 -18 33 -36 33 -40 0 -4 -35 -8 -77 -8 l-77 0 39 40 c21 22
41 40 44 40 3 0 20 -14 38 -32z m33 -85 c0 -4 -17 -24 -37 -45 l-37 -38 -38
37 c-21 20 -38 41 -38 45 0 4 34 8 75 8 41 0 75 -3 75 -7z m-133 -65 c18 -18
33 -36 33 -42 0 -12 -61 -76 -72 -76 -4 0 -8 34 -8 75 0 41 3 75 7 75 4 0 22
-14 40 -32z m173 -43 c0 -41 -3 -75 -7 -75 -4 0 -24 17 -45 37 l-38 37 37 38
c20 21 41 38 45 38 4 0 8 -34 8 -75z m-57 -73 l47 -48 -53 -52 -53 -52 -49 50
-49 50 49 50 c27 28 52 50 55 50 3 0 27 -22 53 -48z m97 -159 c47 -112 80
-202 80 -216 0 -6 -47 35 -104 92 l-105 104 41 49 c23 26 45 48 49 48 4 0 22
-35 39 -77z m-218 28 l42 -39 -98 -106 c-87 -93 -116 -119 -116 -101 0 18 114
285 121 285 6 0 29 -17 51 -39z"
                            fill={
                                logData?.GRID == null
                                    ? "gray" // No data
                                    : logData.GRID <= 0
                                        ? "red" // Grid < 1
                                        : "green" // Grid > 0
                            }

                        />
                        <path d="M8440 14344 c0 -12 3 -14 13 -6 6 5 21 12 32 15 13 3 9 5 -12 6 -24
1 -33 -3 -33 -15z" fill={svgColor} />
                        <path d="M8593 14353 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" fill={svgColor} />
                        <path d="M8748 14353 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
                        <path d="M8898 14353 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" fill={svgColor} />
                        <path d="M8442 14220 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
                        <path d="M8443 14065 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" fill={svgColor} />
                        <path d="M8442 13910 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
                        <path d="M8442 13760 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
                        <path d="M5120 13711 c0 -17 5 -31 10 -31 6 0 10 11 10 24 0 14 -4 28 -10 31
-6 4 -10 -7 -10 -24z"  fill={solarColor} />
                        <path d="M5000 13698 c0 -9 9 -26 20 -39 19 -23 19 -23 20 -3 0 11 -9 29 -20
39 -17 15 -20 16 -20 3z"  fill={solarColor} />
                        <path d="M5232 13688 c-15 -15 -16 -38 -2 -38 12 0 23 25 18 40 -2 7 -7 7 -16
-2z"  fill={solarColor} />
                        <path d="M5075 13616 c-16 -7 -41 -26 -55 -41 -21 -23 -25 -36 -25 -92 0 -62
1 -66 40 -101 l39 -36 16 55 c27 91 29 93 114 104 l76 10 -18 35 c-20 38 -89
80 -132 80 -14 -1 -38 -7 -55 -14z"  fill={solarColor} />
                        <path d="M4910 13610 c0 -11 33 -30 51 -30 8 0 5 7 -6 20 -19 21 -45 27 -45
10z"  fill={solarColor} />
                        <path d="M5313 13610 c-13 -5 -23 -16 -23 -24 0 -13 4 -14 25 -4 14 6 25 17
25 25 0 7 -1 13 -2 12 -2 0 -13 -4 -25 -9z"  fill={solarColor} />
                        <path d="M4893 13485 c11 -7 26 -11 34 -8 12 5 12 7 1 14 -7 5 -22 9 -33 9
-19 -1 -19 -1 -2 -15z"  fill={solarColor} />
                        <path d="M7313 13486 c-100 -33 -188 -108 -232 -199 -93 -191 -15 -414 176
-509 61 -30 76 -33 158 -33 81 0 97 3 155 32 36 17 74 40 86 50 48 42 95 118
115 185 55 180 -21 357 -193 448 -50 27 -74 33 -142 36 -52 3 -96 -1 -123 -10z
m179 -27 c101 -22 180 -86 235 -191 24 -46 27 -65 28 -143 0 -77 -4 -98 -27
-147 -78 -167 -243 -242 -416 -189 -90 27 -159 87 -203 176 -30 60 -31 68 -27
167 2 84 7 111 26 148 30 57 75 105 130 137 90 53 152 63 254 42z"  fill={svgColor} />
                        <path d="M5130 13428 c-7 -24 -14 -46 -17 -50 -2 -5 23 -8 56 -8 65 0 67 2 74
70 2 23 -1 25 -50 28 l-52 3 -11 -43z"  fill={solarColor} />
                        <path d="M5274 13435 c-10 -54 -4 -60 60 -57 54 4 56 5 56 32 0 16 3 35 6 44
5 14 -3 16 -54 16 l-61 0 -7 -35z"  fill={solarColor} />
                        <path d="M5426 13454 c-3 -9 -6 -31 -6 -50 l0 -34 75 0 75 0 0 50 0 50 -69 0
c-54 0 -70 -4 -75 -16z"  fill={solarColor} />
                        <path d="M5600 13420 l0 -52 60 4 c33 2 62 6 65 9 2 3 0 22 -6 42 -6 24 -16
37 -27 37 -9 0 -34 3 -54 6 l-38 7 0 -53z"  fill={solarColor} />
                        <path d="M5740 13458 c0 -7 5 -30 11 -52 l11 -38 51 6 c28 4 54 9 56 12 2 2
-1 22 -8 44 l-12 40 -54 0 c-37 0 -55 -4 -55 -12z"  fill={solarColor} />
                        <path d="M8442 13440 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" fill={solarColor} />
                        <path d="M4925 13380 c-11 -13 -14 -20 -6 -20 18 0 51 19 51 30 0 17 -26 11
-45 -10z"  fill={solarColor} />
                        <path d="M5100 13343 c0 -5 -7 -30 -15 -57 l-15 -49 63 7 c34 4 65 10 69 14 4
4 11 26 16 50 l10 42 -64 0 c-35 0 -64 -3 -64 -7z"  fill={solarColor} />
                        <path d="M5416 13328 c-3 -13 -6 -38 -6 -56 l0 -33 83 3 82 3 0 52 0 53 -76 0
c-71 0 -77 -2 -83 -22z"  fill={solarColor} />
                        <path d="M5605 13303 c0 -23 4 -45 8 -49 4 -4 38 -9 76 -11 l70 -5 -11 39
c-15 55 -23 61 -86 65 l-57 3 0 -42z"  fill={solarColor} />
                        <path d="M5246 13299 c-4 -23 -5 -43 -4 -44 2 -1 31 -5 66 -8 68 -6 66 -7 77
56 l6 37 -69 0 -69 0 -7 -41z"  fill={solarColor} />
                        <path d="M5774 13290 l10 -50 63 0 c69 0 70 1 52 63 l-10 37 -63 0 -63 0 11
-50z"  fill={solarColor} />
                        <path d="M5017 13312 c-19 -20 -23 -42 -7 -42 12 0 32 38 28 51 -2 6 -11 2
-21 -9z"  fill={solarColor} />
                        <path d="M8442 13300 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" fill={svgColor} />
                        <path d="M7883 13243 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
                        <path d="M8020 13246 c0 -9 39 -13 51 -5 10 6 4 9 -18 9 -18 0 -33 -2 -33 -4z" fill={svgColor} />
                        <path d="M8193 13243 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
                        <path d="M8330 13246 c0 -10 28 -13 41 -5 10 6 7 9 -13 9 -16 0 -28 -2 -28 -4z" fill={svgColor} />
                        <path d="M5258 13213 c-22 -3 -30 -12 -38 -41 -19 -72 -19 -72 70 -72 l80 0 0
55 c0 40 -4 55 -14 55 -7 0 -26 2 -42 4 -16 2 -41 2 -56 -1z" fill={solarColor} />
                        <path d="M5046 13163 c-9 -26 -16 -50 -16 -55 0 -4 33 -8 74 -8 l73 0 7 39 c3
22 9 46 12 55 5 14 -4 16 -64 16 l-70 0 -16 -47z" fill={solarColor} />
                        <path d="M5400 13155 l0 -55 95 0 95 0 0 39 c0 70 -2 71 -101 71 l-89 0 0 -55z" fill={solarColor} />
                        <path d="M5623 13202 c-7 -4 -9 -24 -6 -55 l6 -47 83 0 c62 0 82 3 79 13 -2 6
-9 31 -15 55 l-11 42 -62 0 c-34 0 -67 -4 -74 -8z" fill={solarColor} />
                        <path d="M5804 13204 c-7 -3 -7 -19 0 -54 l10 -50 73 0 c53 0 71 3 68 13 -2 6
-9 31 -15 55 l-11 42 -57 -1 c-31 0 -62 -3 -68 -5z" fill={solarColor} />
                        <path d="M6692 13178 c43 -66 42 -61 14 -116 -30 -59 -36 -59 92 -1 45 21 82
42 82 47 0 9 -176 92 -194 92 -4 0 -2 -10 6 -22z" fill={svgColor} />
                        <path d="M6195 13110 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" fill={svgColor} />
                        <path d="M6310 13116 c0 -10 28 -13 41 -5 10 6 7 9 -13 9 -16 0 -28 -2 -28 -4z" fill={svgColor} />
                        <path d="M6463 13113 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z" fill={svgColor} />
                        <path d="M6610 13116 c0 -10 28 -13 41 -5 10 6 7 9 -13 9 -16 0 -28 -2 -28 -4z" fill={svgColor} />
                        <path d="M5020 13056 c-6 -8 -20 -42 -30 -75 l-18 -61 81 0 82 0 16 70 c9 38
13 72 11 75 -13 12 -130 4 -142 -9z" fill={solarColor} />
                        <path d="M5204 13062 c-9 -6 -34 -105 -34 -134 0 -4 43 -8 95 -8 l95 0 0 53
c0 28 3 62 6 75 6 21 4 22 -72 22 -44 0 -84 -4 -90 -8z" fill={solarColor} />
                        <path d="M5390 13018 c0 -29 -3 -63 -6 -75 -6 -23 -6 -23 105 -23 l111 0 0 53
c0 99 2 97 -111 97 l-99 0 0 -52z" fill={solarColor} />
                        <path d="M5625 13003 c4 -38 9 -71 12 -75 2 -5 44 -8 94 -8 49 0 89 3 89 8 0
6 -11 56 -25 120 -5 21 -10 22 -91 22 l-86 0 7 -67z" fill={solarColor} />
                        <path d="M5820 13065 c0 -3 7 -37 16 -76 l16 -69 74 0 74 0 0 28 c0 15 -6 47
-14 72 l-13 45 -77 3 c-42 2 -76 0 -76 -3z" fill={solarColor} />
                        <path d="M7920 13030 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
-11 0 -20 -4 -20 -10z" fill={svgColor} />
                        <path d="M8075 13030 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10
-11 0 -17 -4 -14 -10z"  fill={svgColor} />
                        <path d="M8230 13030 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10
-11 0 -20 -4 -20 -10z"  fill={svgColor} />
                        <path d="M8385 13030 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"  fill={svgColor} />
                        <path d="M8430 12919 c0 -11 5 -17 10 -14 6 3 10 13 10 21 0 8 -4 14 -10 14
-5 0 -10 -9 -10 -21z"  fill={svgColor} />
                        <path d="M5470 12810 c0 -79 0 -80 25 -80 25 0 25 1 25 80 0 79 0 80 -25 80
-25 0 -25 -1 -25 -80z"  fill={solarColor} />
                        <path d="M8430 12775 c0 -15 4 -24 10 -20 6 3 10 12 10 20 0 8 -4 17 -10 20
-6 4 -10 -5 -10 -20z"  fill={svgColor} />
                        <path d="M5180 12660 l-75 -39 390 0 390 0 -75 39 -75 39 -240 0 -240 0 -75
-39z"  fill={solarColor} />

                        <path d="M8430 12621 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 -5
3 -10 -3 -10 -14z" fill={svgColor} />
                        <path d="M9814 12393 c-142 -125 -274 -242 -293 -260 l-36 -32 30 -30 31 -31
119 108 c188 169 389 344 402 349 11 4 204 -159 430 -364 57 -51 106 -93 111
-93 9 0 56 60 50 64 -1 1 -43 38 -93 82 -49 44 -166 147 -260 229 -93 81 -184
161 -201 177 l-32 30 -258 -229z" fill={loadColor} />
                        <path d="M9660 12444 l0 -106 50 42 c57 47 90 96 90 133 0 29 -20 37 -92 37
l-48 0 0 -106z" fill={loadColor} />
                        <path d="M8430 12465 c0 -15 4 -24 10 -20 6 3 10 12 10 20 0 8 -4 17 -10 20
-6 4 -10 -5 -10 -20z" fill={svgColor} />
                        <path d="M10004 12358 c-32 -29 -123 -110 -201 -181 l-143 -128 0 -270 0 -269
73 -2 c39 -1 100 -2 133 -3 l61 -1 7 81 c3 44 6 99 6 123 l0 42 135 0 135 0 0
-124 0 -124 132 4 c73 3 133 6 135 8 2 2 3 122 4 267 l0 264 -78 75 c-126 122
-317 290 -328 290 -6 0 -38 -23 -71 -52z" fill={loadColor} />
                        <path d="M8430 12163 c0 -13 5 -23 10 -23 13 0 13 11 0 30 -8 12 -10 11 -10
-7z" fill={svgColor} />
                        <path d="M8430 12011 c0 -12 5 -21 10 -21 6 0 10 6 10 14 0 8 -4 18 -10 21 -5
3 -10 -3 -10 -14z" fill={svgColor} />
                        <path d="M8870 11993 c0 -5 9 -19 20 -33 25 -32 25 -45 -1 -87 -12 -19 -19
-37 -16 -40 4 -3 47 14 97 38 104 49 104 49 -8 97 -74 33 -92 38 -92 25z" fill={svgColor} />
                        <path d="M8488 11913 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" fill={svgColor} />
                        <path d="M8648 11913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" fill={svgColor} />
                        <path d="M8798 11913 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" fill={svgColor} />
                    </g>
                </svg>
            </div>
        </>
    );
};

export default Load1Svg;



